function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M82.75 41.5C82.75 31.1613 74.3387 22.75 64 22.75C53.6613 22.75 45.25 31.1613 45.25 41.5C45.25 51.8387 53.6613 60.25 64 60.25C74.3387 60.25 82.75 51.8387 82.75 41.5ZM64 60.25C45.3902 60.25 30.25 75.3903 30.25 94V97.5145C30.25 98.5805 30.7035 99.596 31.4975 100.307C40.632 108.492 52.175 113 64 113C75.8252 113 87.3683 108.492 96.5025 100.307C97.2965 99.596 97.75 98.5803 97.75 97.5145V94C97.75 75.3903 82.6097 60.25 64 60.25Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 64,
  y1: 128,
  x2: 64,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5558FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00C0FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 64,
  y1: 113,
  x2: 64,
  y2: 22.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ADDCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5028,
  stopColor: "#EAF6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAF6FF"
})));

var SvgFullHuman = function SvgFullHuman(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFullHuman, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/full-human.d191938a.svg";
export { ForwardRef as ReactComponent };